import { CaretDownIcon } from '@phosphor-icons/react'
import React from 'react'

import { Button } from '@/components/ui/button'
import { DropdownMenu } from '@/components/ui/dropdown-menu'
import { Icon } from '@/components/ui/icon'

import { SmartActionButtonProps } from './smart-action-button.types'

export const SmartActionButton = ({
  label,
  items,
  size = 'small',
  disabled,
}: SmartActionButtonProps) => {
  if (items.length === 0) return null

  if (items.length === 1) {
    const [item] = items
    return (
      <Button
        size={size}
        use="secondary"
        disabled={disabled || item.disabled}
        onClick={() => void item.onClick?.()}
      >
        {item.label}
      </Button>
    )
  }

  return (
    <DropdownMenu
      items={items}
      trigger={({ isOpen }) => (
        <Button active={isOpen} disabled={disabled} size={size} use="secondary">
          {label}
          <Icon icon={CaretDownIcon} size="1.2rem" />
        </Button>
      )}
    />
  )
}
